<template>
  <div>
    <div class="card-container">
      <h4>{{ "اطلاعات تیکت" }}</h4>
      <div class="row">
        <p class="title">{{ "مجموعه درخواست دهنده" }}</p>
        <p class="value">{{ currentProvider.persian_name }}</p>
      </div>
      <div class="row">
        <p class="title">{{ "بخش" }}</p>
        <p class="value">{{ getDepartment(ticket.department) }}</p>
      </div>
      <div class="row">
        <p class="title">{{ "وضعیت تیکت" }}</p>
        <p class="value">{{ getStatus(ticket.status) }}</p>
      </div>
      <div class="row">
        <p class="title">{{ "ارسال شده" }}</p>
        <p class="value">{{ getLastTimeUpdated(ticket.created_at) }}</p>
      </div>
      <div class="row">
        <p class="title">{{ "آخرین بروزرسانی" }}</p>
        <p class="value">{{ getLastTimeUpdated(ticket.updated_at) }}</p>
      </div>
    </div>

    <vs-row>
      <vs-col vs-lg="6" class="pr-2">
        <vs-button @click="reply" class="w-full px-0">{{ "پاسخ" }}</vs-button>
      </vs-col>
      <vs-col vs-lg="6" class="pl-2">
        <vs-button
          :disabled="ticket.status === 'closed'"
          @click="closeTicket"
          color="#EA5455"
          class="w-full px-0"
          >{{ "بستن تیکت" }}</vs-button
        >
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { TicketStatusKey } from "../../../helpers/Constants";
import {
  convertDateToHumanReadable,
  getDepartmentLabel,
  getTicketStatus,
} from "../../../helpers/Functions";
import providerApiService from "../../../services/api/ProviderApiService";

export default {
  name: "DetailsCard.vue",
  components: {},
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      currentProvider: "profile/currentProvider",
    }),
  },
  methods: {
    getStatus(value) {
      return getTicketStatus(value);
    },
    getLastTimeUpdated(value) {
      return convertDateToHumanReadable(value, true);
    },
    getDepartment(value) {
      return getDepartmentLabel(value);
    },
    reply() {
      this.$emit("reply");
    },
    closeTicket() {
      this.$vs.loading();
      providerApiService
        .postCreateOrEditTicket({
          providerId: this.currentProvider.id,
          id: this.ticket.id,
          status: TicketStatusKey.CLOSED,
        })
        .then((result) => {
          this.$vs.notify({
            text: result.message,
            color: "success",
            position: "bottom-center",
          });

          this.ticket = result.data;
        })
        .finally(() => this.$vs.loading.close());
    },
  },
  props: {
    ticket: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss">
.card-container {
  background-color: #ffffff;
  border-radius: 10px;
  box-shadow: 0px 0px 10px 1px rgba(var(--vs-primary), 0.15);
  display: flex;
  flex-direction: column;
  margin-bottom: 15px;

  h4 {
    padding: 15px;
  }

  .row {
    padding: 15px;
    border-top: 1px solid rgba(203, 204, 210, 0.5);

    .title {
      font-size: 0.9rem;
      margin-bottom: 3px;
    }

    .value {
      font-weight: 500;
      color: #232323;
      font-size: 1.1rem;
    }
  }
}
</style>

